import api from './api';

export const ticketService = {
  async getAll() {
    const response = await api.get('/chamados');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/chamados/${id}`);
    return response.data;
  },

  async create(ticketData) {
    const response = await api.post('/chamados', ticketData);
    return response.data;
  },

  async update(id, ticketData) {
    const response = await api.put(`/chamados/${id}`, ticketData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/chamados/${id}`);
  },

  async getInteractions(ticketId) {
    const response = await api.get(`/chamados/${ticketId}/interacoes`);
    return response.data;
  },

  async addInteraction(ticketId, interactionData) {
    const response = await api.post(`/chamados/${ticketId}/interacoes`, interactionData);
    return response.data;
  },

  async generateReport(filters) {
    try {
      const response = await api.post('/chamados/report', filters, {
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Download automático
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const filename = `relatorio_chamados_${new Date().getTime()}.pdf`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (error) {
      console.error('Erro ao gerar relatório:', error);
      throw error;
    }
  },

  // Função auxiliar para pré-visualização (conta quantos tickets serão incluídos)
  async previewReport(filters) {
    try {
      const query = new URLSearchParams();
      
      if (filters.start_date) query.append('start_date', filters.start_date);
      if (filters.end_date) query.append('end_date', filters.end_date);
      if (filters.status && filters.status.length > 0) {
        query.append('status', filters.status.join(','));
      }
      if (filters.client_id) query.append('client_id', filters.client_id);
      if (filters.responsible_id) query.append('responsible_id', filters.responsible_id);
      if (filters.created_by) query.append('created_by', filters.created_by);
      
      const response = await api.get(`/chamados?${query.toString()}`);
      return { count: response.data.length, tickets: response.data };
    } catch (error) {
      console.error('Erro ao carregar preview:', error);
      return { count: 0, tickets: [] };
    }
  }
};